import React from "react";
import { TableRow, TableCell, Skeleton, Box } from "@mui/material";

const BookTableSkeleton = ({ rows = 3 }) => {
  return Array(rows)
    .fill(0)
    .map((_, index) => (
      <TableRow key={index}>
        <TableCell>
          <Skeleton
            variant="rectangular"
            width={60}
            height={80}
            sx={{ borderRadius: 1 }}
          />
        </TableCell>
        <TableCell>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Skeleton variant="text" width={200} />
            <Skeleton variant="text" width={150} />
          </Box>
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={80} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={120} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={70} />
        </TableCell>
        <TableCell>
          <Skeleton
            variant="rectangular"
            width={80}
            height={32}
            sx={{ borderRadius: 1 }}
          />
        </TableCell>
        <TableCell align="right">
          <Skeleton variant="circular" width={40} height={40} />
        </TableCell>
      </TableRow>
    ));
};

export default BookTableSkeleton;
